import { SelectedRadio, UnSelectedRadio } from "../tailwind-components/CustomRadioButton";
export function LabeledRadioButton({selected=false,label,onClick,radioButtonOuter,radioButtonInner,fontSize="16px"}){
    return <div onClick={()=>{
        if(onClick){
            onClick();
        }
    }} className="flex flex-row gap-[10px] items-center  hover:cursor-pointer">
         {selected ? <SelectedRadio /> : <UnSelectedRadio />}
         <p className={`${selected?"text-blue-dark font-bold":"text-grey"} font-roboto text-[${fontSize}]`}>{label}</p>
    </div>
}